<script>
export default {
    name: "AppointmentTab",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 
                rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "appointments-tab": () => import('./tabs/Appointment.vue'),
        "reminder-details-tab": () => import('./tabs/ReminderDetails.vue'),
        "sick-off-note-tab": () => import('./tabs/SickOffNote.vue'),
        "referral-note-tab": () => import('./tabs/ReferralNote.vue'),
    },
}
</script>
<template>
<div class="w-full max-w-none overflow-auto mt-2 p-tiny" style="height: 55vh;">
    <ul class="flex border-b-2 border-gray-500">
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=0" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
            :class="active == 0 ? activeClass : inActiveClass">Make Appointment</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=1"
           class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
           :class="active == 1 ? activeClass : inActiveClass">Create Reminder</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=2"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
          :class="active == 2 ? activeClass : inActiveClass">Sick Off Note</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=3"
         class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
         :class="active == 3 ? activeClass : inActiveClass">Referral Note</a>
      </li>
    </ul>
    <div class="w-full" v-if="active==0">
        <appointments-tab></appointments-tab>
    </div>
    <div class="w-full" v-if="active==1">
        <reminder-details-tab></reminder-details-tab>
    </div>
    <div class="w-full" v-if="active==2">
        <sick-off-note-tab></sick-off-note-tab>
    </div>
    <div class="w-full" v-if="active==3">
        <referral-note-tab></referral-note-tab>
    </div>
</div>
</template>